
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, Database } from 'lucide-react';

interface ConnectionErrorAlertProps {
  connectionError: string | null;
  dataSource: 'supabase' | 'mock';
  onRetry: () => void;
}

export const ConnectionErrorAlert: React.FC<ConnectionErrorAlertProps> = ({
  connectionError,
  dataSource,
  onRetry
}) => {
  // Если данные успешно загружаются из Supabase, не показываем уведомление
  if (dataSource === 'supabase' || !connectionError) return null;

  return (
    <div className="p-4 border bg-muted/30 rounded-md mb-4">
      <div className="flex gap-2">
        <Database className="h-5 w-5 mt-0.5 text-muted-foreground" />
        <div className="flex-1">
          <p className="font-medium text-sm">
            Используются тестовые данные
          </p>
          <p className="text-sm text-muted-foreground mt-1">
            {connectionError}
          </p>
          <div className="mt-3">
            <Button 
              size="sm"
              variant="outline"
              onClick={onRetry}
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Обновить данные
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
